import { render, staticRenderFns } from "./EditWidgetCard.vue?vue&type=template&id=72a58ec3&scoped=true&"
import script from "./EditWidgetCard.vue?vue&type=script&lang=js&"
export * from "./EditWidgetCard.vue?vue&type=script&lang=js&"
import style0 from "./EditWidgetCard.vue?vue&type=style&index=0&id=72a58ec3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a58ec3",
  null
  
)

export default component.exports